export enum ApiResponseStatus {
    Ok = 'ok',
    Error = 'error'
}